import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sections/intro/videoframe_0.webp")